<script>

import _ from 'lodash'
import { validNum } from '@/utils/validate'
import { messageTipModal } from '../../../modal'
import dayjs from 'dayjs'
import { 
    PLAT_PLANNED_BUDGET_TYPE, LIMIT_TYPE, PLAT_TYPE, GROUP_TYPE,  
    ACTION_TYPE, ACT_MATRIX, ACTION_TYPE_DATA  ,ACTION_TYPE_LIST,
    ADJUST_TYPE, ADJUST_TYPE_LIST, ADJUST_VALUE_TYPE, ADJUST_VALUE_TYPE_LIST,
} from './constant'
import busMixin from '@/views/mixins/busMixin'
const emptyDefaultFormData = {
    group: GROUP_TYPE.PLAN,//操作层级
    groupItemList: [],//操作项
    state: '0',//开关
    stateMaxAction: '1',//当天最多操作次数-开关
    plannedBudgetAdjustType: ADJUST_TYPE.INCREASE,//预算类型
    plannedBudget: null,// 预算
    plannedBudgetValueType: ADJUST_VALUE_TYPE.PERCENTAGE,// 预算值类型
    plannedBudgetMax: null,// 预算上限
    plannedBudgetMaxAction: '1',//当天最多操作次数-计划预算


    releaseDate: null,// 投放日期
    releaseDateStart: null,// 投放日期-开始
    releaseDateEnd: null,// 投放日期-结束
    releaseDateMaxAction: '1',//当天最多操作次数-投放日期

    basePriceAdjustType: ADJUST_TYPE.INCREASE,// 基准价调整类型
    basePriceValueType: ADJUST_VALUE_TYPE.PERCENTAGE,// 基准价调整值类型
    basePrice: null,// 基准价
    basePriceMax: null,// 基准价上限
    basePriceMaxAction: '1',//当天最多操作次数-基准价

    secondPriceAdjustType: ADJUST_TYPE.INCREASE,// 基准价调整类型
    secondPriceValueType: ADJUST_VALUE_TYPE.PERCENTAGE,// 基准价调整值类型
    secondPrice: null,// 基准价
    secondPriceMax: null,// 基准价上限
    secondPriceMaxAction: '1',//当天最多操作次数-二阶价格
    
    thirdPriceAdjustType: ADJUST_TYPE.INCREASE,// 三阶出价调整类型
    thirdPriceValueType: ADJUST_VALUE_TYPE.PERCENTAGE,// 三阶出价调整值类型
    thirdPrice: null,// 三阶出价
    thirdPriceMax: null,// 三阶出价上限
    thirdPriceMaxAction: '1',//当天最多操作次数-三阶价格
}
export default {
    name: 'ActionForm',
    props: [ 'platId', 'configAutn', 'defaultFormData','screenType' ],
    inject: [ 'validFormItem' , 'global'],
    mixins: [ busMixin ],
    data() {
        return {
            formData: {
                ...emptyDefaultFormData
               
            },
            actionTypeList: [
                ...ACTION_TYPE_LIST
            ],
            dimension: '2'
        }
    },
    render(h) {
        
        const _this = this;
        const nodes = [ this.$slots.default ];
         // 操作层级
         
        const groupNode = _this.creatNode(h, 'ElRadioGroupButton', { 
            list: this.dimension =='4'?  this.groupList.filter((v)=> {
                return v.value == '3'
            }): this.groupList,
            key: 'group',
            on: {
                change() {
                    const formData = _.omit({ ...emptyDefaultFormData }, ['group']);
                    formData.group = _this.formData.group;
                     _this.formData = formData;
                    // _this.formData.group = GROUP_TYPE.PLAN;
                    // _this.$message.error('产研同学正在快马加鞭支持中...有想法可以联系相关同学沟通呦～')
                }
            }
        });
        const validGroupItem = (rule, value, callback) => {
            if((_this.screenType || 0) <= (+value + 1)) {
                callback();
            }else {
                callback(new Error('不支持的操作层级'));
            }
        };
        nodes.push(
            h('ElFormItem', {
                props: {
                    label: '操作层级',
                    prop: 'group',
                    rules: {
                        required: true,validator: validGroupItem, trigger: 'blur'
                    }
                },
                scopedSlots: {
                    default: ()=> [ groupNode],
                }
            })
        );

        // 操作项
        const groupItemListNode = _this.creatNode(h, 'ElCheckboxGroup', { 
            list: _this.actMatrixList.map(key=> {
                return {
                    value: key,
                    label: _this.groupValueLabel[key]
                }
            }),
            key: 'groupItemList',
        })
        nodes.push(
            h('ElFormItem', {
                props: {
                    label: '操作项',
                    prop: 'groupItemList',
                    rules:{
                        required: true, message: '请勾选操作项并填写相关的内容', trigger: 'blur'
                    }
                },
                scopedSlots: {
                    default: ()=> [groupItemListNode],
                }
            })
        );
        // 
        nodes.push(
            ..._this.actionFormList(
                h,
                // 保证顺序一致
                _this.actMatrixList.filter(key=> _this.formData.groupItemList.includes(key))
            )
        )
        return h('ElForm', 
            {
                props: {
                    model: _this.formData,
                    ..._this.$attrs,
                    labelWidth: '120px',
                },
                ref: 'formRef',
                on: {
                    validate: _this.handleValidate,
                },
                nativeOn: {
                    submit: (event)=> {
                        event.preventDefault()
                    }
                }
            }, 
        nodes)
    },
    computed: {
        actMatrixList() {
            if (this.platId && this.formData.group) {
                //  return this.configAutn[this.platId][this.formData.group] || []
                 return this.global.operation_config[this.platId]?.[this.formData.group] || []
            }else {
                return []
            }
        },
        groupListData() {
            if (this.platId) {
                 return this.global.operation_config[this.platId]?.groupListData || []
            }else {
                return []
            }
        },
        groupList() {
            const groupData = this.global.operation_config[this.platId] || {};
            const groupKeys = Object.keys(groupData);
            console.log(this.groupListData, groupKeys, 'groupKeysgroupKeys');
            return this.groupListData.filter(v=> groupKeys.includes(v.value + ''))
        },
        groupValueLabel() {
            return this.actionTypeList.reduce((pre, item)=> {
                pre[item.value] = item.label;
                return pre
            }, {})
        }
    },
    created() {
        
    },
    methods: {
        actionFormList(h, list) {
            const _this = this;
            const validReleaseDate = (rule, value, callback)=> {
                const field = rule.field;
                const start = _this.formData[`${field}Start`];
                const end = _this.formData[`${field}End`];
                if(!start && !end) {
                   callback(new Error('请输入未来日期范围'))
                   return
                };
                if(!validNum(start) || !validNum(end)) {
                    callback(new Error('请输入数字'))
                    return
                };
                if(start.indexOf('.') > -1 || end.indexOf('.') > -1) {
                    callback(new Error('请输入整数'))
                    return
                };
                if(+start > +end) {
                    callback(new Error('开始日期不能大于结束日期'))
                    return
                };
                if( +start < 1 || +start > 100 || ( ( +end < 1 || +end > 100 ) && end !== '9999' )) {
                    callback(new Error('请输入1-100之间的数字, 结束日期可为9999'))
                    return
                };
               callback()
            };
            const validPrice = (rule, value, callback)=> {
                // basePriceAdjustType basePriceValueType basePrice basePriceMax
                console.log(rule, value , 'rule');
                const field = rule.field;
                const adjustType = this.formData[`${field}AdjustType`];
                const valueType = this.formData[`${field}ValueType`];
                const price = this.formData[`${field}`];
                const priceMax = this.formData[`${field}Max`];
                const priceMaxAction = this.formData[`${field}MaxAction`];
                const isAdjust = adjustType === ADJUST_TYPE.ADJUST; //是否为调整至
                if(!(price && (isAdjust || priceMax) )) {
                    callback(new Error('请输入价格'))
                    return
                };
                if(!(validNum(price) && ( isAdjust || validNum(priceMax) ))) {
                    callback(new Error('请输入数字'))
                    return
                };
                if( adjustType === ADJUST_TYPE.INCREASE &&  valueType === ADJUST_VALUE_TYPE.PERCENTAGE) {
                    if( +price >= 100) {
                        callback(new Error('提高百分比不能大于等于100%'))
                        return
                    }
                }
                if( +price <= 0) {
                    callback(new Error('不能小于等于0'))
                    return
                };
                
                if(!validNum(priceMaxAction) || priceMaxAction.indexOf('.') > -1 ) {
                    callback(new Error('当天最多操作次数必须为整数'))
                    return
                };
                if( +priceMaxAction < 1 || +priceMaxAction >100) {
                    callback(new Error('当天最多操作次数不能小于1或大于100'))
                    return
                };
                callback()
            };
            const maximumTipNode = h("ElTooltip", {
                props: {
                    placement: 'top',
                    effect: 'dark',
                },
            },[ h('div', {
                slot: 'content'
            }, [
                 h('p', '提高时表示最多可调整的限制，降低时表示最低可调整的限制，举例：'),
                h('p', '当前出价是100，提升10%，正常来说会提升至110，如果输入的最多调整至是105，那么就只会调整至105，'),
                h('p', '如果当前的出价已经是105或者105以上了，那么也不会调整。因为已经大于等于了最多调整至的金额。'),
            ]) , h('i', { class:'el-icon-question' }) ])
            // 当天最多操作
            const maxActionNode = (key)=> {
                const list = [ ACTION_TYPE.STATE, ACTION_TYPE.RELEASE_DATE ].map(key=> _.toLower(key));
                const isDisabled = list.some(v=> _.toLower(key).indexOf(v)> -1)
                return h('span', {  class: 'font12px text-color-normal ml20', }, [
                    '当天最多操作',
                    h('ElTooltip', {
                        props: {
                            placement: 'top',
                            content: isDisabled ? '暂不支持修改' :'按照目标维度分别当天最多操作次数',
                            effect: 'dark',
                        }
                    }, [
                         this.creatNode(h, 'ElInput', {
                            key,
                            attrs: {
                                placeholder: '请输入',
                            },
                            class: 'mr10 ml10',
                            style: { width: '100px' },
                            props: {
                                disabled: isDisabled || this.global.isView,
                            }
                        }),
                    ]),
                    '次'
                ])
            }
            const nodeData = {
                [ACTION_TYPE.STATE]:  h('ElFormItem', {
                    props: {
                        label: '开关',
                        prop: 'state',
                        required: true,
                    },
                    scopedSlots: {
                        default: ()=> [
                            this.creatNode(h, 'ElSwitch', {
                                key: 'state',
                                props: {
                                    activeValue: "1",
                                    inactiveValue: "0",
                                }
                            }),
                            maxActionNode('stateMaxAction')
                        ],
                    }
                }),
                [ACTION_TYPE.PLANNED_BUDGET]: h('ElFormItem', {
                    props: {
                        label: '计划预算',
                        prop: 'plannedBudget',
                        rules:[
                            {
                                required: true, validator: validPrice, trigger: 'blur'
                            }
                        ]
                    },
                    scopedSlots: {
                        default: ()=> [
                            h('div',null, [
                                    this.creatNode(h, 'ElSelect', {
                                        key: 'plannedBudgetAdjustType',
                                        list: [ ...ADJUST_TYPE_LIST ],
                                        class: 'mr10',
                                        props: {
                                            placeholder: '请选择调整类型',
                                        },
                                        on: {
                                            change: (value)=> {
                                                if( ADJUST_TYPE.ADJUST === value) {
                                                    this.formData.plannedBudgetValueType = ADJUST_VALUE_TYPE.FIXED;
                                                    this.formData.plannedBudget = '';
                                                }
                                            }
                                        }
                                    }),
                                    [
                                        this.formData.plannedBudgetAdjustType === ADJUST_TYPE.ADJUST? null :

                                        this.creatNode(h, 'ElSelect', {
                                            key: 'plannedBudgetValueType',
                                            list: [ ...ADJUST_VALUE_TYPE_LIST ],
                                            class: 'mr10',
                                            props: {
                                                placeholder: '请选择调整值类型'
                                            }
                                        })
                                    ],
                                    this.creatNode(h, 'ElInput', {
                                        key: 'plannedBudget',
                                        class: 'mr10',
                                        attrs: {
                                            placeholder: '请输入数值'
                                        },
                                        style: {
                                            width: '100px'
                                        },
                                        on: {
                                            blur: (event)=> {
                                                 event.stopPropagation();
                                                this.priceWarnTip({
                                                    label: '计划预算',
                                                    type: this.formData.plannedBudgetAdjustType,
                                                    valueType: this.formData.plannedBudgetValueType,
                                                    price: this.formData.plannedBudget,
                                                })
                                            }
                                        }
                                    }),
                                    h('span', { class: 'font12px text-color-gray mr10' }, [
                                        this.formData.plannedBudgetValueType === ADJUST_VALUE_TYPE.FIXED? '￥' :'%'
                                    ]),
                                    [
                                        this.formData.plannedBudgetAdjustType === ADJUST_TYPE.ADJUST? null :
                                        [
                                            h('span', { class: 'font12px text-color-gray mr10' }, [`${this.formData.plannedBudgetAdjustType === ADJUST_TYPE.INCREASE? '最多' : '最低'}调整至`, maximumTipNode]),
                                            this.creatNode(h, 'ElInput', {
                                                key: 'plannedBudgetMax',
                                                attrs: {
                                                    placeholder: '请输入数值'
                                                },
                                                style: {
                                                    width: '100px'
                                                }
                                            }),
                                            h('span', { class: 'font12px text-color-gray mr10' }, ['￥'])
                                        ]
                                    ],
                                     maxActionNode('plannedBudgetMaxAction')
                                ]),
                               
                        ],
                    }
                }),
                [ACTION_TYPE.RELEASE_DATE]: h('ElFormItem', {
                    props: {
                        label: '投放日期',
                        prop: 'releaseDate',
                        rules:{
                            required: true, validator: validReleaseDate, trigger: 'blur'
                        }
                    },
                    scopedSlots: {
                        default: ()=> [
                            h('div', {
                                class: 'font12px text-color-normal'
                            } , [
                                '未来第',
                                this.creatNode(h, 'ElInput', {
                                    key: 'releaseDateStart',
                                    attrs: {
                                        placeholder: '明日为1'
                                    },
                                    style: {
                                        width: '200px'
                                    },
                                    class: 'mr10 ml10',
                                }),
                                '日-未来第',
                                this.creatNode(h, 'ElInput', {
                                    key: 'releaseDateEnd',
                                    attrs: {
                                        placeholder: '明日为1'
                                    },
                                    style: {
                                        width: '200px'
                                    },
                                    class: 'mr10 ml10',
                                }),
                                '日',
                                maxActionNode('releaseDateMaxAction')
                            ]),
                            h('span', { class: 'font12px text-color-gray' }, '示例：未来第【1】日 - 未来第【3】日，今天是10月1日，则表示修改投放日期为【10月2日】-【10月4日】，结束时间是 9999 时为不限结束日期')
                        ],
                    }
                }),
                [ACTION_TYPE.BASE_PRICE]: h('ElFormItem', {
                    props: {
                        label: '基础价格',
                        prop:'basePrice',
                        rules:{
                            required: true, validator: validPrice, trigger: 'blur'
                        }
                    },
                    scopedSlots: {
                        default: ()=> [
                            // _this.formData.basePriceAdjustType,
                            this.creatNode(h, 'ElSelect', {
                                key: 'basePriceAdjustType',
                                list: [ ...ADJUST_TYPE_LIST ],
                                class: 'mr10',
                                props: {
                                    placeholder: '请选择调整类型',
                                },
                                on: {
                                    blur: (value)=> {
                                      
                                    }
                                }
                            }),
                            [
                                 this.formData.basePriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                 this.creatNode(h, 'ElSelect', {
                                    key: 'basePriceValueType',
                                    list: [ ...ADJUST_VALUE_TYPE_LIST ],
                                    class: 'mr10',
                                    props: {
                                        placeholder: '请选择调整值类型'
                                    },
                                    on: {
                                        change: (value)=> {
                                            if( ADJUST_TYPE.ADJUST === value) {
                                                this.formData.basePriceValueType = ADJUST_VALUE_TYPE.FIXED;
                                                this.formData.basePriceMax = '';
                                                this.formData.basePrice = '';
                                            }
                                        }
                                    }   
                                }),
                            ],
                            this.creatNode(h, 'ElInput', {
                                key: 'basePrice',
                                class: 'mr10',
                                attrs: {
                                    placeholder: '请输入数值'
                                },
                                style: {
                                    width: '100px'
                                },
                                on: {
                                    blur: (event)=> {
                                         event.stopPropagation();
                                        this.priceWarnTip({
                                            label: '基础价格',
                                            type: this.formData.basePriceAdjustType,
                                            valueType: this.formData.basePriceValueType,
                                            price: this.formData.basePrice,
                                        })
                                    }
                                }
                            }),
                            h('span', { class: 'font12px text-color-gray mr10' }, [
                                this.formData.basePriceValueType === ADJUST_VALUE_TYPE.FIXED? '￥' :'%'
                            ]),
                            [
                                this.formData.basePriceAdjustType === ADJUST_TYPE.ADJUST? null :
                               [
                                 h('span', { class: 'font12px text-color-gray mr10' }, [`${this.formData.basePriceAdjustType === ADJUST_TYPE.INCREASE? '最多' : '最低'}调整至`, maximumTipNode]),
                                    this.creatNode(h, 'ElInput', {
                                        key: 'basePriceMax',
                                        attrs: {
                                            placeholder: '请输入数值'
                                        },
                                        style: {
                                            width: '100px'
                                        }
                                    }),
                                    h('span', { class: 'font12px text-color-gray mr10' }, ['￥']),
                               ]
                            ],
                            maxActionNode('basePriceMaxAction')
                        ],
                    }
                }),
                [ACTION_TYPE.SECOND_PRICE]: h('ElFormItem', {
                    props: {
                        label: '二阶价格',
                        prop:'secondPrice',
                        rules:{
                            required: true, validator: validPrice, trigger: 'blur'
                        }
                    },
                    scopedSlots: {
                        default: ()=> [
                            this.creatNode(h, 'ElSelect', {
                                key: 'secondPriceAdjustType',
                                list: [ ...ADJUST_TYPE_LIST ],
                                class: 'mr10',
                                props: {
                                    placeholder: '请选择调整类型',
                                },
                                on: {
                                    change: (value)=> {
                                        if( ADJUST_TYPE.ADJUST === value) {
                                            this.formData.secondPriceValueType = ADJUST_VALUE_TYPE.FIXED;
                                            this.formData.secondMaxPrice = '';
                                            this.formData.secondPrice = '';
                                        }
                                    }
                                }
                            }),
                            [
                                this.formData.secondPriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                this.creatNode(h, 'ElSelect', {
                                    key: 'secondPriceValueType',
                                    list: [ ...ADJUST_VALUE_TYPE_LIST ],
                                    class: 'mr10',
                                    props: {
                                        placeholder: '请选择调整值类型'
                                    }
                                })
                            ],
                            this.creatNode(h, 'ElInput', {
                                key: 'secondPrice',
                                class: 'mr10',
                                attrs: {
                                    placeholder: '请输入数值'
                                },
                                style: {
                                    width: '100px'
                                },
                                on: {
                                    blur: (event)=> {
                                         event.stopPropagation();
                                        this.priceWarnTip({
                                            label: '二阶价格',
                                            type: this.formData.secondPriceAdjustType,
                                            valueType: this.formData.secondPriceValueType,
                                            price: this.formData.secondPrice,
                                        })
                                    }
                                }
                            }),
                            h('span', { class: 'font12px text-color-gray mr10' }, [
                                this.formData.secondPriceValueType === ADJUST_VALUE_TYPE.FIXED? '￥' :'%'
                            ]),
                            [
                                this.formData.secondPriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                [
                                    h('span', { class: 'font12px text-color-gray mr10' }, [`${this.formData.secondPriceAdjustType === ADJUST_TYPE.INCREASE? '最多' : '最低'}调整至`, maximumTipNode]),
                                    this.creatNode(h, 'ElInput', {
                                        key: 'secondPriceMax',
                                        attrs: {
                                            placeholder: '请输入数值'
                                        },
                                        style: {
                                            width: '100px'
                                        }
                                    }),
                                    h('span', { class: 'font12px text-color-gray mr10' }, ['￥']),
                                ]
                            ],
                            maxActionNode('secondPriceMaxAction')
                        ],
                    }
                }),
                [ACTION_TYPE.THIRD_PRICE]: h('ElFormItem', {
                    props: {
                        label: '三阶价格',
                        prop:'thirdPrice',
                        rules:{
                            required: true, validator: validPrice, trigger: 'blur'
                        }
                    },
                    scopedSlots: {
                        default: ()=> [
                            this.creatNode(h, 'ElSelect', {
                                key: 'thirdPriceAdjustType',
                                list: [ ...ADJUST_TYPE_LIST ],
                                class: 'mr10',
                                props: {
                                    placeholder: '请选择调整类型',
                                },
                                on: {
                                    change: (value)=> {
                                        if( ADJUST_TYPE.ADJUST === value) {
                                            this.formData.thirdPriceValueType = ADJUST_VALUE_TYPE.FIXED;
                                            this.formData.thirdMaxPrice = '';
                                            this.formData.thirdPrice = '';
                                        }
                                    }
                                }
                            }),
                            [
                                this.formData.thirdPriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                this.creatNode(h, 'ElSelect', {
                                    key: 'thirdPriceValueType',
                                    list: [ ...ADJUST_VALUE_TYPE_LIST ],
                                    class: 'mr10',
                                    props: {
                                        placeholder: '请选择调整值类型'
                                    }
                                })
                            ],
                            this.creatNode(h, 'ElInput', {
                                key: 'thirdPrice',
                                class: 'mr10',
                                attrs: {
                                    placeholder: '请输入数值'
                                },
                                style: {
                                    width: '100px'
                                },
                                on: {
                                    blur: (event)=> {
                                        event.stopPropagation();
                                        this.priceWarnTip({
                                            label: '三阶价格',
                                            type: this.formData.thirdPriceAdjustType,
                                            valueType: this.formData.thirdPriceValueType,
                                            price: this.formData.thirdPrice,
                                        })
                                    }
                                }

                            }),
                            h('span', { class: 'font12px text-color-gray mr10' }, [
                                this.formData.thirdPriceValueType === ADJUST_VALUE_TYPE.FIXED? '￥' :'%'
                            ]),
                            [
                                this.formData.thirdPriceAdjustType === ADJUST_TYPE.ADJUST? null :
                                [
                                    h('span', { class: 'font12px text-color-gray mr10' }, [`${this.formData.thirdPriceAdjustType === ADJUST_TYPE.INCREASE? '最多' : '最低'}调整至`, maximumTipNode]),
                                    this.creatNode(h, 'ElInput', {
                                        key: 'thirdPriceMax',
                                        attrs: {
                                            placeholder: '请输入数值'
                                        },
                                        style: {
                                            width: '100px'
                                        }
                                    }),
                                    h('span', { class: 'font12px text-color-gray mr10' }, ['￥']),
                                ]
                            ],
                            maxActionNode('thirdPriceMaxAction')
                        ],
                    }
                }),
            };
            return list.map(key=> h('div', { class: 'mb20 p10', style: { 'backgroundColor': '#f5f7fa' } }, [ nodeData[key] ]))
        },
        // 自定义v-model
        formCustomModel(key, isNum = false) {
            return {
                props: {
                    value: this.formData[key],
                },
                on: {
                    input: (val)=> {
                        this.formData[key] = val;
                    }
                }
            }
        },
        creatNode(h, name, params) {
            const { key } = params
            const defaultAttr = _.merge(this.formCustomModel(key), { props: { disabled: this.global.isView } }) 
            switch (name) {
                case 'ElRadioGroupButton': {
                    const { list, ...attrs } = params;
                    const nodes = list.map(v=> h('ElRadioButton', { props: { label: v.value } }, [ v.label ]))
                    return h('ElRadioGroup', _.merge(defaultAttr, attrs , { scopedSlots: { default: ()=> nodes} }) );
                }
                case 'ElCheckboxGroup': {
                    const { list, ...attrs } = params;
                    const nodes = list.map(v=> h('ElCheckbox', { props: { label: v.value } }, [ v.label ]))
                    return h('ElCheckboxGroup', _.merge( defaultAttr , attrs , { scopedSlots: { default: ()=> nodes} }) );
                }
                case 'ElRadioGroup': {
                    const { list, ...attrs } = params;
                    const nodes = list.map(v=> h('ElRadio', { props: { label: v.value } }, [ v.label ]))
                    return h('ElRadioGroup', _.merge( defaultAttr , attrs , { scopedSlots: { default: ()=> nodes} }) );
                }
                case 'ElSwitch': {
                    return h('ElSwitch', _.merge( defaultAttr , params ) );
                }
                case 'ElDatePicker': {
                    return h('ElDatePicker', _.merge( defaultAttr , params ) );
                }
                case 'ElInput': {
                    return h('ElInput', _.merge( defaultAttr , params ) );
                }
                case 'ElSelect': {
                    const { list,...attrs } = params;
                    const nodes = list.map(v=> h('ElOption', { props: { label: v.label, value: v.value } }, [ v.label ]))
                    return h('ElSelect', _.merge( defaultAttr, attrs, { scopedSlots: { default: ()=> nodes} }) );
                }
                default:
                    break;
            }
        },
        async validateFn() {
            const valid = await this.$refs.formRef.validate();
            const formData = this.formData;
            // 格式化成后端需要的数据
           console.log( formData.groupItemList, this.actMatrixList,' formData.groupItemList');
            const operation_items = formData.groupItemList.filter(v=> {
                return this.actMatrixList.includes(v);
            }).reduce((pre, key)=> {
                const targetKey = ACTION_TYPE_DATA[key];
                // 日期单独处理
                if (ACTION_TYPE.RELEASE_DATE === key) {
                    const start = formData['releaseDateStart'];
                    const end = formData['releaseDateEnd'];
                    pre[targetKey] =  { 
                        value: `${start}/${end}`, 
                        max_operation_num: formData[`${key}MaxAction`]
                    };
                }else if( [
                    ACTION_TYPE.BASE_PRICE,
                    ACTION_TYPE.SECOND_PRICE,
                    ACTION_TYPE.THIRD_PRICE,
                    ACTION_TYPE.PLANNED_BUDGET
                ].includes(key) ) {
                    // {"operator":"increase","type":"percentage","value":0.5,"boundary":0.04, max_operation_num: 2}
                    pre[targetKey] = {
                        operator: formData[`${key}AdjustType`],
                        type: formData[`${key}ValueType`],
                        value: formData[key],
                        boundary: formData[`${key}Max`],
                        max_operation_num: formData[`${key}MaxAction`]
                    };
                } else {
                    pre[targetKey] = {
                        value: formData[key],
                        max_operation_num: formData[`${key}MaxAction`]
                    };
                }
                return pre;
            }, {});
           console.log(operation_items, 'operation_items');
            if (valid) {
                return { operation_level: this.formData.group, operation_items: JSON.stringify(operation_items) }
            }
        },
        handleValidate(key, valid, info) {
            const data = {
                group: '操作-操作层级',
                groupItemList: '操作-操作项',
                state: '操作-开关',
                plannedBudget: '操作-计划预算',
                releaseDate: '操作-投放日期',
                basePrice: '操作-基础出价',
                secondPrice: '操作-二阶出价',
                thirdPrice: '操作-三阶出价',
            };
            if (!valid) {
                this.validFormItem(`${data[key]}：${info}`);
            }
        },
        // 出价提示
        async priceWarnTip({ type, valueType, price, label }) {
            await new Promise((resolve)=> {
               setTimeout(resolve, 300)
            });
            if(
                type === ADJUST_TYPE.INCREASE && valueType === ADJUST_VALUE_TYPE.PERCENTAGE && price
            ) {
                if(price >= 100) {
                    
                     const onSubmit = (type)=> {
                        console.log(label);
                        vm.close()
                    }
                    const { vm } = messageTipModal({
                        props: {
                            message: `您设置的【${label}】提高【${price}%】,操作存在风险，暂不支持批量操作！`,
                            closeText: '取消'
                        },
                        cbs: { onSubmit }
                    });
                }else if( price >=50 ){
                    
                     const onSubmit = (type)=> {
                        console.log(label);
                        vm.close()
                    }
                    const { vm } = messageTipModal({
                            props: {
                            message: `您设置的【${label}】提高【${price}%】,操作可能存在风险，请谨慎操作？`,
                            closeText: '已知晓'
                        },
                        cbs: { onSubmit }
                    })
                }
                
            }
        },
        setFormData(data) {
            // ...data 
            const operation_items = data.operation_items;
            const operation_items_keys = Object.keys(operation_items);
            const keyData = _.invert(ACTION_TYPE_DATA);
            const formData = operation_items_keys.reduce((pre, key)=> {
                const targetData = operation_items[key];
                if(key === ACTION_TYPE_DATA[ACTION_TYPE.RELEASE_DATE]) {
                    const [ start, end ] = targetData.value.split('/')
                    pre['releaseDateStart'] = start;
                    pre['releaseDateEnd'] = end;
                }else if( [
                    ACTION_TYPE_DATA[ACTION_TYPE.BASE_PRICE],
                    ACTION_TYPE_DATA[ACTION_TYPE.SECOND_PRICE],
                    ACTION_TYPE_DATA[ACTION_TYPE.THIRD_PRICE],
                    ACTION_TYPE_DATA[ACTION_TYPE.PLANNED_BUDGET]
                ].includes(key) ) {
                    pre[`${keyData[key]}AdjustType`] = targetData.operator;
                    pre[`${keyData[key]}ValueType`] = targetData.type;
                    pre[keyData[key]] = targetData.value;
                    pre[`${keyData[key]}Max`] = targetData.boundary;
                }else {
                    pre[keyData[key]] = targetData.value;
                }
                pre[`${keyData[key]}MaxAction`] = targetData.max_operation_num;
                return pre;
            }, {});
            console.log(operation_items_keys.map(v=>keyData[v]), keyData, operation_items_keys);
            this.formData = {
                ...emptyDefaultFormData, 
                group: data.operation_level,
                groupItemList: operation_items_keys.map(v=>keyData[v]),
                ...formData
            }
        }
    },
    mounted() {
        const fn = (val, isChange = true)=> {
            this.dimension = val;
            if(val =='4' && isChange) {
                console.log(this.groupList, val, '---------------');
                const list = this.groupList.filter((v)=> {
                    return v.value == '3'
                });
                this.formData.group = _.head(list).value || '';
            }
        }
        this.createBus('dimensionChange', fn)
    },
    watch: {
        platId() {
            this.formData = { ...emptyDefaultFormData }
        },
    }
}
</script>

<style lang="scss" scoped>
.company-text {
    font-size: 12px;
    padding-left: 10px;
    color: #606266;
}
</style>